






































import { defineComponent } from "@vue/composition-api";
import { Location } from "vue-router";
import BaseSpinner from "@/components/BaseSpinner";

export default defineComponent({
  name: "BaseButton",
  components: { BaseSpinner },
  props: {
    fullWidth: { type: Boolean },
    to: { type: Object as () => Location },
    href: { type: String },
    secondary: { type: Boolean },
    gradient: { type: Boolean },
    outline: { type: Boolean },
    outlineSecondary: { type: Boolean },
    gray: { type: Boolean },
    green: { type: Boolean },
    red: { type: Boolean },
    white: { type: Boolean },
    small: { type: Boolean },
    medium: { type: Boolean },
    round: { type: Boolean },
    disabled: { type: Boolean },
    transparent: { type: Boolean },
    textLike: { type: Boolean },
    linkLike: { type: Boolean },
    loading: { type: Boolean },
    target: { type: String },
    spinnerColor: { type: String },
    spinnerSize: { type: String },
  },
  setup(props, { emit }) {
    const onClick = (e: MouseEvent) => {
      if (props.disabled || props.loading) return;
      emit("click", e);
    };
    return {
      onClick,
    };
  },
});
